/** Note: these endpoints are not under `/api/v1`. */
export const conversationsEndpoints = {
  /** GET `?page=&pageSize=`: a page of the project's comments. POST `{ createdBy, message }`: adds one. */
  collection: (projectId: string) => `/api/projects/${encodeURIComponent(projectId)}/conversations`,
}
